export default "__VITE_ASSET__CiZ02F9W__"